module.exports = __webpack_public_path__ + "img/daylight_4.bfc2d047.png";